import theme from '../../styles/theme';

export const aliceLikeButtonStyle = {
  '&&': {
    display: 'flex',
    borderRadius: 2,
    padding: '11px 16px',
    textTransform: 'uppercase',
    cursor: 'pointer',
    backgroundColor: theme.colors.white,
    columnGap: '8px',
    alignItems: 'center',
    border: '1px solid #A8A8A8',
    boxSizing: 'border-box',
  },

  '&&,&& p': {
    margin: 0,
    fontSize: 12,
    fontWeight: 700,
    lineHeight: 1,
    color: theme.colors.black,
    fontFamily: theme.fonts.bold,
    textDecoration: 'none',
  },

  '& svg': {
    width: 16,
    height: 16,
  },

  '&&:disabled,&&:disabled p,&&:disabled svg path': {
    opacity: 0.9,
    cursor: 'not-allowed',
    color: theme.colors.inactiveBtn,
    fill: theme.colors.inactiveBtn,
  },
};

export const aliceLikeButtonHoverStyle = {
  transition: 'background-color 0.25s ease-out, color 0.25s ease-out, border 0.25s ease-out',

  '&&:not(:disabled):hover': {
    backgroundColor: theme.colors.secondary,
    borderColor: theme.colors.secondary,
    color: theme.colors.white,

    '& path,& p': {
      color: theme.colors.white,
      fill: theme.colors.white,
      transition: 'background-color 0.25s ease-out, color 0.25s ease-out, border 0.25s ease-out',
    },
  },
};
